var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.valid),expression:"valid"}],staticClass:"vue-barcode-element"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }